import api from 'api';

import type { Action } from 'redux';
import type { AppDispatch } from 'types';

/**
 * Refresh Redux serverConfig from the API for the current session
 */
const refreshServerConfig = async (dispatch: AppDispatch) => {
  const response = await api.get('/admin/server-config');
  if (response.data?.data) {
    dispatch({
      type: 'setServerConfig',
      serverConfig: response.data.data
    } as Action<'setServerConfig'>);
  }
};

export default refreshServerConfig;
